import React from 'react';

function ProjectList({ headerText, selectedProjectId, projects, onClick }) {
	return (
		<div className="c-list">
			<ul>
				{projects.map(project => (
					<li
						className={`c-list__item ${project.project_id === selectedProjectId ? 'is-active' : null}`}
						key={project.project_id}
						onClick={onClick.bind(null, project.project_id)}
					>

						{project.name}
					</li>
				))}
			</ul>
		</div>
	);
}

export default ProjectList;



// WEBPACK FOOTER //
// ./src/js/project-v2/ProjectList.js